export const SET_DATA = 'profileOnboarding/SET_DATA'
export const SET_IS_FETCHING = 'profileOnboarding/SET_IS_FETCHING'
export const RESET_DATA = 'profileOnboarding/RESET_DATA'
